
import { useDispatch } from 'react-redux'
import { openCheckInDialog as openCheckIn, openUpdateProfileDialog as openUpdateProfile } from '../services/dialogService';
export const useDialogs = () => {
  
  const dispatch = useDispatch();

  const openUpdateProfileDialog = (selectedItems) => {

    openUpdateProfile({ selectedItems });

    // const dialogOptions = {
    //   title: "Update Profile",
    //   responsive: false,
    //   destroyOnClose: true,
    //   maskClosable: false,
    //   footer: null,
    //   width: "800px",
    //   styles: { body: { height: 500 } },
    // };

    // const taskDialogProps = {
    //   selectedItems: selectedItems,
    //   user: 'cssadmin',
    //   onComplete: () => getTasks(currentParams),
    // }

    // dispatch({ type: 'MODAL_SHOW', payload: { modalType: 'UPDATE_PROFILE', modalProps: dialogOptions, modalContentProps: taskDialogProps }});
  }

  const openCheckInDialog = (selectedItems) => {

    openCheckIn({ selectedItems });

    // const dialogOptions = {
    //   title: "Check In",
    //   responsive: true,
    //   minWidth: 600,
    //   maxWidth: 1000
    // };

    // const taskDialogProps = {
    //   checkinFiles: selectedItems
    // }

    // dispatch({ type: 'MODAL_SHOW', payload: { modalType: 'CHECK_IN', modalProps: dialogOptions, modalContentProps: taskDialogProps }});
  }

  return {
    openCheckInDialog,
    openUpdateProfileDialog
  };
}
